import React from "react";
import { Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ACCENT, ACCENT_DARK } from "../constants/quotationConstants";

const { Text } = Typography;

export default function AddCustomTemplateCard({ onClick }) {
  const cardW = 168;
  const cardH = Math.round(cardW * (1123 / 794));

  return (
    <div onClick={onClick} style={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", width: cardW }}>
      <div
        style={{
          width: cardW,
          height: cardH,
          background: "#F7FAFD",
          position: "relative",
          border: `2px dashed ${ACCENT}`,
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          transition: "background 120ms",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#EAF2FA";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#F7FAFD";
        }}
      >
        <Button shape="circle" type="primary" icon={<PlusOutlined />} size="large" />
      </div>
      <Text strong style={{ fontSize: 13, marginTop: 10, textAlign: "center", color: ACCENT_DARK }}>
        Add Custom Template
      </Text>
      <div style={{ fontSize: 11, marginTop: 2, textAlign: "center", color: "#8A94A3" }}>Start from a blank sheet</div>
    </div>
  );
}
